import {
  AgoraAccessTypeLabels,
  AgoraAccessTypes,
  AccessTypeLabels,
  AccessTypes
} from 'shared/constants'
import { SocketRoles } from './constants'

export const getTeacherInfo = socket => {
  const studentLength = socket.classroom?.students?.length || 0
  return studentLength ? ` (${studentLength} alumnos)` : ` (Sin alumnos)`
}

export const getTooltipInfo = (currentSocket = {}, sockets = []) => {
  const { role, classroom } = currentSocket

  if (role === SocketRoles.STUDENT) {
    return sockets.find(({ _id }) => _id === classroom?.teacher)?.name || ''
  }

  if (role === SocketRoles.TEACHER) {
    return sockets
      .filter(({ _id }) => classroom?.students?.includes(_id))
      .map(student => student?.name)
      .filter(Boolean)
  }

  return []
}

export const getAccessLabel = accessType => {
  return (
    AgoraAccessTypeLabels[accessType] || AccessTypeLabels[accessType] || 'Profe'
  )
}

export const isAppDevice = device => {
  return device?.toLowerCase()?.startsWith('app')
}

export const categorizeStudents = students => {
  const trainees = students.filter(
    student =>
      student?.accessType === AgoraAccessTypes.FORMACION ||
      student?.accessType === AccessTypes.TRAINEE
  )

  const leads = students.filter(
    student =>
      student?.accessType === AgoraAccessTypes.FEEDBACK ||
      student?.accessType === AccessTypes.TRIAL
  )

  const others = students.filter(
    student =>
      student?.accessType === AgoraAccessTypes.ALUMNO ||
      student?.accessType === AccessTypes.STUDENT
  )

  return { trainees, leads, others }
}
